import script from "./MoneyManagerFilterBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoneyManagerFilterBar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__